<template>
  <div>
    <v-row dense class="mt-10">
      <v-col cols="12" md="6">
        <px-autocomplete-cotacao
          dense
          class="rounded-tag-small"
          v-model="cotacoes" @change="onChangeCotacao"/>
      </v-col>
      <v-col cols="12" md="6">
        <px-select-enum
          dense
          multiple
          chips
          small-chips
          deletable-chips
          class="rounded-tag-small"
          label="Modo de visualização"
          v-model="viewType"
          :items="viewOptions"/>
      </v-col>
    </v-row>
    <px-line-filter :options="statusOptions" v-model="selectedStatus"
                    :on-select-item="emitChange">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click="emitChange">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </template>
        <px-confirm-dialog ref="confirm"/>
        <span>Atualizar matriz</span>
      </v-tooltip>
      <px-matriz-resposta-view-options/>
      <px-matriz-resposta-filters-details :cotacoes="cotacoes" @change="onChangeFilter"/>
    </px-line-filter>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { CLEAR_ACTION } from '@/store/matriz/actions.type';
import MatrizRespostaFiltersDetails from './MatrizRespostaFiltersDetails.vue';
import MatrizRespostaViewOptions from './MatrizRespostaViewOptions.vue';

export default {
  props: {
    selectedCotacoes: Array,
  },
  data() {
    return {
      selectedOption: null,
    };
  },
  computed: {
    ...mapGetters('matriz', ['viewOptions', 'statusOptions']),
    cotacoes: {
      get() {
        return this.$store.getters['matriz/cotacoes'];
      },
      set(matriz) {
        this.$store.dispatch('matriz/cotacoes', matriz);
      },
    },
    selectedStatus: {
      get() {
        return this.$store.getters['matriz/selectedStatus'];
      },
      set(selectedStatus) {
        this.$store.dispatch('matriz/selectedStatus', selectedStatus);
      },
    },
    viewType: {
      get() {
        return this.$store.getters['matriz/viewType'];
      },
      set(viewType) {
        this.$store.dispatch('matriz/viewType', viewType);
      },
    },
  },
  methods: {
    ...mapActions('matriz', {
      clear: CLEAR_ACTION,
    }),
    onChangeFilter() {
      this.emitChange();
    },
    emitChange() {
      this.$emit('change');
    },
    onChangeCotacao() {
      this.clear();
      this.emitChange();
    },
  },
  created() {
    if (this.selectedCotacoes && this.selectedCotacoes.length) {
      this.cotacoes = [...this.selectedCotacoes];
    }
    if (!this.selectedStatus) {
      [this.selectedStatus] = this.statusOptions;
    }
  },
  components: {
    pxMatrizRespostaFiltersDetails: MatrizRespostaFiltersDetails,
    pxMatrizRespostaViewOptions: MatrizRespostaViewOptions,
  },
};
</script>
